import React, { useCallback, useState, useEffect } from 'react';
import { useModal } from '@tencent/adp-fe-hooks';
import { Drawer } from '@tencent/spaui';
import { loadAssistant } from '@tencent/ams-assistant-ui-bridge';

import reportHub from '@/common/report-hub';
import globalStore from '@/stores';

const AIAiAssistant = (props: any) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [app, setApp] = useState<any>(null);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        setError(null);

        const instance = await loadAssistant('agency', {
          props,
          domGetter: '#micro-app-container',
          beforeMount(info) {
            console.log('子应用开始渲染', info.name);
          },
          afterMount(appInfo) {
            console.log('子应用渲染结束', appInfo.name);
            setLoading(false);
          },
        });
        setApp(instance);
      } catch (error) {
        setLoading(false);
        setError(`加载失败: ${error instanceof Error ? error.message : '未知错误'}`);
      }
    })();
  }, []);

  useEffect(
    () => () => {
      if (!!app && app.mounted) {
        app.hide();
      }
    },
    [app],
  );

  return (
    <div
      id="micro-app-container"
      className="tw-w-full tw-h-full"
      style={{
        isolation: 'isolate',
        contain: 'layout style paint',
      }}
    >
      {loading && (
        <div className="tw-flex tw-items-center tw-justify-center tw-h-full tw-bg-gray-01 tw-rounded-lg tw-border tw-border-gray-0616a">
          <div className="tw-text-center tw-p-6">
            <div className="tw-animate-spin tw-w-8 tw-h-8 tw-border-2 tw-border-blue-06 tw-border-t-transparent tw-rounded-full tw-mx-auto tw-mb-4"></div>
            <div className="tw-text-gray-10 tw-text-sm">正在加载AI助手...</div>
          </div>
        </div>
      )}
      {error && (
        <div className="tw-flex tw-items-center tw-justify-center tw-h-full tw-bg-gray-01 tw-rounded-lg tw-border tw-border-gray-0616a">
          <div className="tw-text-center tw-p-6">
            <div className="tw-text-gray-10 tw-text-sm tw-mb-2">AI助手组件加载失败</div>
            <div className="tw-text-gray-08 tw-text-xs tw-mb-4">{error}</div>
            <button
              onClick={() => window.location.reload()}
              className="tw-px-4 tw-py-2 tw-bg-blue-06 tw-text-white-00 tw-rounded tw-text-sm hover:tw-bg-blue-07 tw-transition-colors"
            >
              刷新页面
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

const useAIAssistant = () => {
  const [createModalInstance, modalContextHolder] = useModal();

  // 唤起AI助手
  const showAIAssistant = useCallback((options?: any) => {
    createModalInstance({
      component: Drawer,
      componentProps: {
        className: 'l-drawer l-drawer-bg',
        headerStyle: { display: 'none' },
        hideFooter: true,
        width: 'calc(100vw - 120px)',
      },
      body: AIAiAssistant,
      bodyProps: {
        ...options || {},
        accountId: globalStore.account.bm_id || globalStore.account.agency_uid,
        reportAction: reportHub.reportAction,
      },
    });
  }, [createModalInstance]);

  return {
    showAIAssistant,
    aiAssistantModal: modalContextHolder,
  };
};

export default useAIAssistant;
